import { render, staticRenderFns } from "./ChangeBookingContact.vue?vue&type=template&id=80afc050&scoped=true"
import script from "./ChangeBookingContact.vue?vue&type=script&lang=js"
export * from "./ChangeBookingContact.vue?vue&type=script&lang=js"
import style0 from "./ChangeBookingContact.vue?vue&type=style&index=0&id=80afc050&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80afc050",
  null
  
)

export default component.exports